import { getMessages } from 'app/store/constants';

export const BOARD_IMPORT_READONLY = getMessages().getText('board_settings.import.readonly');
